import type { CartQuantities, UpdateCartResponse } from '../../sharedTypes';

export const CART = {
  SET_CART_DATA: 'cart/set_cart_data',
  SET_PREV_PURCHASED_VARIANTS: 'cart/set_prev_purchased_variants',
  FAILED_CART_REQUEST: 'cart/failed_cart_request',
  REQUEST_ADD_TO_CART: 'cart/request_add_to_cart',
  REQUEST_REMOVE_FROM_CART: 'cart/request_remove_from_cart',
  RECEIVE_UPDATE_CART: 'cart/receive_update_cart',
  RECEIVE_UPDATE_CART_ERROR: 'cart/receive_update_cart_error',
  END_LOAD_PREVIOUS_CART: 'cart/end_load_previous_cart',
};

export type SetCartDataAction = {
  type: typeof CART.SET_CART_DATA;
  payload: UpdateCartResponse;
};

export type FailedCartRequestAction = {
  type: typeof CART.FAILED_CART_REQUEST;
};

export type RequestAddToCartAction = {
  type: typeof CART.REQUEST_ADD_TO_CART;
  variantId: string;
  productId: string;
  buttonLocation: string;
  ctaName: string;
  selectedCategoryId: string | null;
};

export type RequestRemoveFromCartAction = {
  type: typeof CART.REQUEST_REMOVE_FROM_CART;
  variantId: string;
  productId: string;
  buttonLocation: string;
  ctaName: string;
  selectedCategoryId: string | null;
};

export type ReceiveUpdateCartAction = {
  type: typeof CART.RECEIVE_UPDATE_CART;
  variantId: string;
  payload: UpdateCartResponse;
};

export function setCartData(payload: UpdateCartResponse) {
  return {
    type: CART.SET_CART_DATA,
    payload,
  };
}

export function setPrevPurchasedVariants(payload: CartQuantities) {
  return {
    type: CART.SET_PREV_PURCHASED_VARIANTS,
    payload,
  };
}

export function endLoadPrevCart() {
  return {
    type: CART.END_LOAD_PREVIOUS_CART,
  };
}

export function failedCartRequest() {
  return {
    type: CART.FAILED_CART_REQUEST,
  };
}

export function requestAddToCart(
  variantId: string,
  productId: string,
  buttonLocation: string,
  ctaName: string,
  selectedCategoryId: string | null,
) {
  return {
    type: CART.REQUEST_ADD_TO_CART,
    variantId,
    productId,
    buttonLocation,
    ctaName,
    selectedCategoryId,
  };
}

export function requestRemoveFromCart(
  variantId: string,
  productId: string,
  buttonLocation: string,
  ctaName: string,
  selectedCategoryId: string | null,
) {
  return {
    type: CART.REQUEST_REMOVE_FROM_CART,
    variantId,
    productId,
    buttonLocation,
    ctaName,
    selectedCategoryId,
  };
}

export function receiveUpdateCart(variantId: string, cartData: UpdateCartResponse) {
  return {
    type: CART.RECEIVE_UPDATE_CART,
    variantId,
    payload: cartData,
  };
}
export function receiveUpdateCartError(variantId: string) {
  return {
    type: CART.RECEIVE_UPDATE_CART_ERROR,
    variantId,
  };
}
